<template>
  <br />
  <br />
  <h2>Deseja se descadastrar da nossa newsletter?</h2>

  <div class="col-12 col-sm-12 col-md-6">
    <div class="form-group">
      <br />
      <label for="user_type">Selecione um motivo</label>
      <select class="form-control" id="user_type" v-model="motivo">
        <option value="Não quero mais receber e-mails">Não quero mais receber e-mails</option>
        <option value="Recebo muitos e-mails">Recebo muitos e-mails</option>
        <option value="Assunto não me interessa">Assunto não me interessa</option>
        <option value="Outro">Outro</option>
      </select>
    </div>
  </div>

  <div class="col-12 col-sm-12 col-md-6" v-if="motivo == 'Outro'">
    <div class="form-group">
      <br />
      <label for="user_type">Descrição</label>
      <textarea
        id="justificativa"
        name="justificativa"
        rows="4"
        cols="50"
        style="width: 100%"
        v-model="justificativa"
        class="form-control"
      ></textarea>
    </div>
  </div>

  <div class="col-12 col-sm-12 col-md-6">
    <button class="btn btn-info" type="button" @click="this.confirmar()">Confirmar desinscrição</button>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import sweetAlert from "./controller/sweetAlert";

export default {
  mixins: [sweetAlert],

  components: { Loading },

  props: ["hash", "campanha_id"],

  data() {
    return {
      motivo: "",
      justificativa: "",
    };
  },

  mounted() {
    console.log("HELP APELIDO");
  },

  methods: {
    confirmar() {
      if (!this.motivo) {
        this.showErrorMessageWithButton("Ops...", "Selecione um dos motivos listados.");
      } else if (this.motivo == "Outro" && !this.justificativa) {
        this.showErrorMessageWithButton("Ops...", "Informe o motivo da desinscrição.");
      } else {
        let data = {
          campanha_id: this.campanha_id,
          hash: this.hash,
          motivo: this.motivo,
        };

        if (this.motivo == "Outro") {
          data.motivo = "Outro. " + this.justificativa;
        }

        console.log("Atualizando");
        console.log(data);

        axios
          .post("/desist/newsletter", data)
          .then((response) => {
            this.showSuccessMessageWithButtonAndRedirect("Sucesso", response.data.msg, "/");
          })
          .catch((error) => {
            this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
            console.log(error.response.data);
          });
      }
    },
  },
};
</script>
